var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBalloons = function SvgBalloons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.995 12.557c2.484 0 4.498-2.35 4.498-5.248s-2.014-5.248-4.498-5.248-4.498 2.35-4.498 5.248 2.014 5.248 4.498 5.248m0 0-1.35 1.8a.75.75 0 0 0 .6 1.199h1.5a.75.75 0 0 0 .6-1.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.152 15.556a2.64 2.64 0 0 0 .283 3.399 2.64 2.64 0 0 1 0 3.731M8.997 2.014a4 4 0 0 0-2.251-.7c-2.484 0-4.499 2.35-4.499 5.248s2.015 5.248 4.499 5.248a4 4 0 0 0 2.249-.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.748 11.807 1.35 1.8a.75.75 0 0 1-.6 1.199h-1.5a.75.75 0 0 1-.6-1.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.59 14.806a2.64 2.64 0 0 1-.282 3.399 2.637 2.637 0 0 0 0 3.731"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M1.125 17.805a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m9.746 5.249a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m11.247-2.224a.375.375 0 1 1 0-.75m-.001.75a.375.375 0 1 0 0-.75m.758-10.521a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75"
  })));
};
export default SvgBalloons;